export default __webpack_public_path__ + "static/media/step - 6.314b9885.jpeg";